import React, { useState } from 'react';
import { Container, Content, Column, Heading, Item, Title, Description, StoryMenu, StoryItem } from './MainNav.style';
import { pushAnyClickEvent } from '../../tracking/events';

const MainNav = ({cms, activeMenu, isHoverNav}) => {
    const [isHoverMenu, setIsHoverMenu] = useState(false);
    return (
        <Container isVisible={isHoverNav || isHoverMenu} onMouseEnter={()=> setIsHoverMenu(true)} onMouseLeave={()=> setIsHoverMenu(false)}>
            <Content>
                { Array.isArray(activeMenu)
                    ? activeMenu.map((category, i) =>
                        <Column key={i}>
                            <Heading>{category.text}</Heading>
                            {category.navItems.map((ele, i) =>
                                <React.Fragment key={i}>
                                    { ele.header &&
                                        <Item href={ele.url} onClickCapture={() => pushAnyClickEvent({linkUrl: ele.url, linkText: ele.title})}>
                                            <Title>{ele.title}<i className="fas fa-chevron-right"/></Title>
                                            <Description>{ele.description}</Description>
                                        </Item>
                                    }
                                </React.Fragment>
                            )}
                        </Column>
                    )
                    : <Column> {/** For STORIES menu */}
                        <StoryMenu>
                            {activeMenu && activeMenu.primary &&
                                <StoryItem isPrimary={true}>
                                    {activeMenu.primary.map((item,i) =>
                                        <a key={i} href={item.url} onClickCapture={() => pushAnyClickEvent({linkUrl: item.url, linkText: item.title})}><span>{item.title}</span></a>
                                    )}
                                </StoryItem> 
                            }
                             {activeMenu && activeMenu.secondary &&
                                <div>
                                    {activeMenu.secondary.map((item,i) =>
                                        <StoryItem key={i}> 
                                            <a href={item.url} onClickCapture={() => pushAnyClickEvent({linkUrl: item.url, linkText: item.title})}><span>{item.title}</span></a>
                                        </StoryItem>
                                    )}
                                </div> 
                            }
                        </StoryMenu>
                      
                    </Column>
                }
            </Content>
        </Container>
    );
}
 
export default MainNav;
